<template>
    <div :class="showmode">
        <div class="select">
            <loader :flag="loading"></loader>
            <div id="dropin-container"></div>
            <div v-if="instance">
                <button class="btn btn-secondary" v-if="showbutton" @click="onSubmit" v-lang.agregarMedioPago></button>
            </div>
        </div>
        <div class="payment-data">
            <loader :flag="loadingInformation"></loader>
            <div>
                <!-- { "cardType": "Visa", "last4": "7777", "maskedNumber": "401200******7777", "expirationDate": "02/2023", "default": true, "imageUrl": "https://assets.braintreegateway.com/payment_method_logo/visa.png?environment=sandbox", "type": "card" } -->
                <div class="media" v-if="defaultPayment">
                    <div class="media-left">
                        <img class="media-object" :src="defaultPayment.imageUrl" alt="">
                    </div>
                    <div class="media-body">
                        <div v-if="defaultPayment.type === 'card'">
                            <strong>{{ defaultPayment.cardType }} {{ this.translate('terminadaEn') }} {{ defaultPayment.last4 }} {{ this.translate('expiraEl') }} {{ defaultPayment.expirationDate }}</strong>
                        </div>
                        <div v-else>
                            <strong>Paypal - {{ defaultPayment.email }}</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { apis } from '../../services/api';
let paymentsApi = apis.paymentsApi;
let dropin = require('braintree-web-drop-in');
export default {
    name: 'braintree-profile',
    props: {
        'paymentmethod': {
            type: Object,
            required: false,
            default: null
        },
        'pmconfig': {
            type: Object,
            required: false,
            default: null
        },
        'showbutton': {
            type: Boolean,
            required: false,
            default: true
        },
        'showmode': {
            type: String,
            required: false,
            default: 'default'
        }
    },
    data () {
        return {
            instance: null,
            paymentMethodConfigurationId: 0,
            loading: true,
            loadingInformation: true,
            cardsInformation: []
        };
    },
    mounted () {
        this.language = this.$getLang();
        if (!this.pmconfig) {
            console.log('mounted Braintree profile no customerId', this.paymentmethod.options);
            this.init(this.paymentmethod.options.env.clientKey);
        } else {
            // paymentsApi.
            console.log('mounted Braintree with config', this.pmconfig);
            let data = {
                payment_method_data_id: this.pmconfig.id,
                payment_method_id: this.paymentmethod.id
            };
            paymentsApi.prepare(data).then((result) => {
                console.log('preparar ', result);
                this.init(result.clientToken);
            });
            if (this.showmode === 'payment') {
                paymentsApi.information(data).then((result) => {
                    console.log('informacion ', result);
                    this.loadingInformation = false;
                    this.cardsInformation = result.paymentMethods;
                });
            }
        }
    },
    computed: {
        defaultPayment () {
            console.log('this.cardsInformation', this.cardsInformation);
            if (this.cardsInformation && this.cardsInformation.length) {
                let card = this.cardsInformation.find(c => c.default);
                console.log('default payment', card);
                return card;
            }
            return null;
        }
    },
    methods: {
        onSubmit (saveConfig = true) {
            return new Promise((resolve, reject) => {
                this.instance.requestPaymentMethod((requestPaymentMethodErr, payload) => {
                    console.log('success', requestPaymentMethodErr, payload.nonce);
                    let callbackFunction = (customerId, pmConfigurationId, payload = {}) => {
                        let data = {
                            payment_method_data_id: pmConfigurationId,
                            payment_method_id: this.paymentmethod.id,
                            config: {
                                customerId: customerId
                            },
                            nonce: payload.nonce
                        };
                        paymentsApi.config(data).then((result) => {
                            console.log('configurar id', result);
                            this.paymentMethodConfigurationId = result.id;
                            this.$emit('success', result);
                            resolve(result);
                        }).catch(reject);
                    };
                    if (saveConfig) {
                        if (!(this.paymentMethodConfigurationId > 0)) {
                            let data = {
                                payment_method_id: this.paymentmethod.id,
                                nonce: payload.nonce
                            };
                            paymentsApi.create(data).then((result) => {
                                if (result) {
                                    callbackFunction(result.id, this.paymentMethodConfigurationId);
                                } else {
                                    callbackFunction(result.id, this.paymentMethodConfigurationId, payload);
                                }
                            }).catch(reject);
                        } else {
                            callbackFunction(0, this.paymentMethodConfigurationId);
                        }
                    } else {
                        let data = {
                            payment_method_id: this.paymentmethod.id,
                            nonce: payload.nonce
                        };
                        resolve(data);
                    }
                });
            });
        },
        init (authorization) {
            let options = {
                locale: this.translate('locale'),
                vaultManager: true,
                container: '#dropin-container',
                authorization: authorization
            };
            if (this.paymentmethod.options.paypal) {
                options.paypal = { // https://developers.braintreepayments.com/guides/paypal/vault/javascript/v3
                    env: 'sandbox',
                    flow: 'vault'
                };
            }
            dropin.create(options, (createErr, instance) => {
                console.log(authorization, instance, createErr);
            }, (createErr, instance) => {
                this.loading = false;
                console.log(authorization, instance, createErr);
                this.instance = instance;
            });
        }
    }
};
</script>

<style scoped>
    .payment .payment-data,
    .default .select {
        display: block;
    }
    .payment .select,
    .default .payment-data {
        display: none;
    }
    .media-left, .media-body {
        vertical-align: middle;
    }
    .loading-container {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/components/BraintreePayment.vue